import type { PropsWithChildren, ReactElement } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

export type ThumbnailErrorBoundaryProps = PropsWithChildren<{
  fallback: ReactElement | null;
}>;

export const ThumbnailErrorBoundary = (props: ThumbnailErrorBoundaryProps) => {
  return <ErrorBoundary {...props} />;
};
